import { render, staticRenderFns } from "./GoCatPreferential.vue?vue&type=template&id=5a9e0093&"
import script from "./GoCatPreferential.vue?vue&type=script&lang=js&"
export * from "./GoCatPreferential.vue?vue&type=script&lang=js&"
import style0 from "./GoCatPreferential.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports